module.exports = __webpack_public_path__ + "assets/img/init.90a66a4c.png";